<template>
<div>
    <div class="mb-1">
        <a href @click.prevent="toggleAll">
            <i class="fas fa-fw" :class="allCollapsed ? 'fa-chevron-right' : 'fa-chevron-down'" aria-hidden="true"></i>
            {{ allCollapsed ? 'Expand All' : 'Collapse All' }}
        </a>
    </div>

    <info-widget :collapsible="true" :is-expanded="expanded.plan" @toggle_expand="expanded.plan = !expanded.plan">
        <template v-slot:title>Plan Information</template>
        <plan-details :plan="plan" />
    </info-widget>

    <info-widget :collapsible="true" :is-expanded="expanded.base" @toggle_expand="expanded.base = !expanded.base">
        <template v-slot:title>Tier 1 (Base)</template>
        <tier-details :tier="plan" :plan="plan" :is-base="true" />
    </info-widget>

    <info-widget v-for="(tier, idx) in sortedTiers" :key="tier.id" :collapsible="true" :is-expanded="expanded[tier.id] !== false" @toggle_expand="expanded[tier.id] = expanded[tier.id] === false">
        <template v-slot:title>Tier {{ idx + 2 }}</template>
        <tier-details :tier="tier" :plan="plan" :is-base="false" />
    </info-widget>
</div>
</template>

<script>
import InfoWidget from '@/components/InfoWidget'
import PlanDetails from './PlanDetails'
import TierDetails from './TierDetails'

// A plan's settings and tiers as collapsible cards.
export default {
    components: {InfoWidget, PlanDetails, TierDetails, },
    props: ['plan', ],
    data() {
        // Tiers are keyed by id and count as expanded until set to false.
        return {
            expanded: {plan: true, base: true},
        }
    },
    computed: {
        sortedTiers() {
            return [...this.plan.tiers].sort((a, b) => a.starts_after_months - b.starts_after_months)
        },
        allCollapsed() {
            return !this.expanded.plan && !this.expanded.base && this.plan.tiers.every(t => this.expanded[t.id] === false)
        },
    },
    methods: {
        toggleAll() {
            const value = this.allCollapsed
            this.expanded.plan = value
            this.expanded.base = value
            this.plan.tiers.forEach(t => {this.expanded[t.id] = value})
        },
    },
}
</script>
